import React,{useState,useEffect} from "react";
import "./ShouldDo.scss";
import {cards} from "./CardList.json" 
import Footer from "../Footer/Footer";
import { GA_Push } from "../../Services/GoogleAnalytics";

export default function ShouldDo() {
  let [index, setIndex] = useState(1)

  const changeIndex = (type) => {
    if(type === "+"){
      index < 3 && setIndex(index + 1)
    }
    else{
      index > 1 && setIndex(index - 1)
    }
  }

  function handleAnalitics(name){
    GA_Push("navigation_events" , `Download ${name}`  ,"","navigation")
  }
  return (
    <section className="should_do watch sec-5">
      <div className="sd_wrapper">
        <div className="sd_title">
              <div className="suitcase"></div>
              <div className="title_text">מה שכדאי לעשות</div>
        </div>
        <div className={`sd_gallery stage-${index}`}>
          {
            cards.map((c, index) => (
              <div className="card" key={index}>
                <div className={`card_image card_image_${c.image}`}></div>
                <div className="card_genre">{c.gener}</div>
                <div className="card_title">{c.title}</div>
                <div className="card_desc">{c.desc}</div>
                <div className="card_format">{c.format}</div>
                <a target="_blank" href={c.link} onClick={()=> handleAnalitics(c.title)} className="card_btn">להורדה</a>
              </div>
            ))
          }
        </div>
        <div className="dots_wrapper">
          <div className={`dot_left ${index === 3 && "in-active"}`} onClick={() => changeIndex("+")}><i className="fas fa-arrow-left"></i></div>
          <div className="dots">
            <div className={`dot ${index === 1 && "active"}`}></div>
            <div className={`dot ${index === 2 && "active"}`}></div>
            <div className={`dot ${index === 3 && "active"}`}></div>
          </div>
          <div className={`dot_right ${index === 1 && "in-active"}`} onClick={() => changeIndex("")}><i className="fas fa-arrow-right"></i></div>
        </div>
      </div>
      <Footer isAbsolute={false}/>
    </section>
  )
}
